import Cookies from "universal-cookie";

import Axios from "../helper/axios";
import { urls, LIVECHAT_DOMAIN } from "../constants/constants";
import { TOKEN_NAMES } from "../constants/constants";
import { removeCookie } from "../helper/helpers";

const axios = new Axios();
const cookies = new Cookies();
export default class UserService {
  setToken(token, maxAge = 600) {
    cookies.set(TOKEN_NAMES.OTP, token, {
      maxAge,
      path: "/",
      sameSite: "none",
      secure: true,
    });
    localStorage.setItem(TOKEN_NAMES.OTP, token);
  }
  getToken() {
    const tokenData = cookies.get(TOKEN_NAMES.OTP);
    return tokenData;
  }

  getSSOToken() {
    const tokenData = localStorage.getItem(TOKEN_NAMES.SSO);
    return tokenData;
  }

  getMsToken() {
    const tokenData = cookies.get(TOKEN_NAMES.MS);
    return tokenData;
  }
  removeMsTokens() {
    removeCookie(
      TOKEN_NAMES.MS,
      process.env.REACT_APP_ENV !== "dev" && { domain: LIVECHAT_DOMAIN },
      false
    );
    removeCookie(
      TOKEN_NAMES.MS_LOGIN,
      process.env.REACT_APP_ENV !== "dev" && { domain: LIVECHAT_DOMAIN },
      false
    );
    removeCookie(
      TOKEN_NAMES.TOKEN,
      process.env.REACT_APP_ENV !== "dev" && { domain: LIVECHAT_DOMAIN },
      false
    );
  }
  removeToken() {
    cookies.remove(TOKEN_NAMES.OTP);
    cookies.remove();
    localStorage.removeItem(TOKEN_NAMES.OTP);
  }
  removeSSOToken() {
    cookies.remove(TOKEN_NAMES.TOKEN);
    localStorage.removeItem(TOKEN_NAMES.SSO);
  }
  loginUser(username, password) {
    const cred = {
      username,
      password,
    };
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/login`,
      data: cred,
    };

    return axios.post(option);
  }

  sendOtp(token, target) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/sendLiveChatOtp`,
      data: { otpChannel: target },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios.post(option);
  }

  verifyUser(token, otp) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/otp`,
      data: { otp: otp },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios.otppost(option);
  }

  loginWithEhr(ehrName, launch, practiceId) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/loginwithehr`,
      params: { ehrName, launch, practiceId },
    };

    return axios.get(option);
  }

  getUserDetailsWithEhr(params) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/nextgenresponse`,
      params: params,
    };

    return axios.get(option);
  }

  getDepartment(params) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/getDepartments`,
      params: {
        practiceId: params,
      },
    };

    return axios.get(option);
  }

  logoutApi(logoutReason = 'manual'){
    const option = {
      url: `${urls.aspariaBackend}api/v1/logout`,
      data: { logoutReason },
      headers: {},
    };
    return axios.post(option);
  }

  getPatients(data) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/patient/getPatientListApi`,
      data,
    };

    return axios.post(option);
  }

  getProviders(params, searchQuery = "") {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/getProviders${
        searchQuery ? "?searchWith=" + searchQuery : ""
      }`,
      params,
    };

    return axios.get(option);
  }

  getResources(params, searchQuery) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/getResources${
        searchQuery ? "?searchWith=" + searchQuery : ""
      }`,
      params,
    };

    return axios.get(option);
  }

  getAppointmentList(data) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/patient/getPatientListApi`,
      data,
    };

    return axios.post(option);
  }

  getOtherPatientList(userId) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/patient/getPatients?flag=others&pageNo=1&pageSize=15`,
    };

    return axios.get(option);
  }

  getUserDetails(phone) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/patient/getByNumber?cellPhone=${phone}`,
    };
    return axios.get(option);
  }

  getTagConversation() {
    const option = {
      url: `${urls.aspariaBackend}api/v1/patient/getTags`,
    };
    return axios.get(option);
  }

  tagPatient(data) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/patient/tagPatient`,
      data,
    };
    return axios.put(option);
  }

  untagPatient(id) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/patient/unTagPatient`,
      data: { id },
    };
    return axios.put(option);
  }

  getbroadcastFilesList() {
    const option = {
      url: `${urls.aspariaBackend}api/v1/broadcast/getBroadcastList`,
    };

    return axios.get(option);
  }
  forgetPassword(userIdentification) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/user/forgotPassword?userIdentification=${userIdentification}`,
    };
    return axios.get(option);
  }
  getOtp(username, isSMS) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/resendOtp`,
      data: { username, otpChannel: isSMS ? "phone" : "email" },
    };
    return axios.post(option);
  }
  setNewPassword(key, password) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/setNewPassword?key=${key}`,
      data: { password },
    };
    return axios.post(option);
  }
  checkUrlExpiry(key) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/checkUrlExpiry`,
      headers: {
        Authorization: `Bearer ${key}`,
      },
    };
    return axios.get(option);
  }
  getProfileData() {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/profile`,
    };
    return axios.get(option);
  }
  saveProfileData(data) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/profile`,
      data,
    };
    return axios.put(option);
  }
  verifySSO(token) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/sso`,
      data: {},
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios.post(option);
  }

  getAccountsForHA(page = 1, searchQuery = "") {
    const option = {
      url: `${urls.aspariaBackend}api/v1/getAccountsForHA${
        page ? "?page=" + page : ""
      }${searchQuery ? "&name=" + searchQuery : ""}`,
    };
    return axios.get(option);
  }

  getPortalAccountsForAdmin(page = 1, searchQuery = "", pageSize) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/getAllLiveChatCustomersFromPortal${
        page ? "?page=" + page : ""
      }${searchQuery ? "&name=" + searchQuery : ""}${
        pageSize ? "&pageSize=" + pageSize : ""
      }`,
    };
    return axios.get(option);
  }

  getPortalUsersForAdmin(
    practiceId,
    page = 1,
    searchQuery = "",
    forTransfer,
    type
  ) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/getLiveChatUsersFromPortal${
        practiceId ? "?practiceId=" + practiceId : ""
      }${page ? "&page=" + page : ""}${
        searchQuery ? "&name=" + searchQuery : ""
      }${forTransfer ? "&forTransfer=" + forTransfer : ""}${
        type ? "&type=" + type : ""
      }`,
    };
    return axios.get(option);
  }

  loginWithAdmin(id) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/getLiveChatTokenForSATS${
        id ? "?id=" + id : ""
      }`,
    };
    return axios.get(option);
  }

  getMsLoginUrl() {
    return `${urls.aspariaBackend}api/v1/loginwithmicrosoft`;
  }

  getNotifications(page, limit) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/notification/getNotifications${
        page ? "?pageNo=" + page : ""
      }${limit ? "&pageSize=" + limit : ""}`,
    };
    return axios.get(option);
  }

  transferPatient = (data) => {
    const option = {
      url: `${urls.aspariaBackend}api/v1/patient/transferPatient`,
      data: data,
    };
    return axios.put(option);
  };

  transferChat = (data) => {
    const option = {
      url: `${urls.aspariaBackend}api/v1/livechat-agent/transferChat`,
      data: data,
    };
    return axios.put(option);
  };

  getSubAccounts(page = 1, searchQuery = "") {
    const option = {
      url: `${urls.aspariaBackend}api/v1/getSubAccountsbyUser${
        page ? "?page=" + page : ""
      }${searchQuery ? "&name=" + searchQuery : ""}`,
    };
    return axios.get(option);
  }

  getDepartments(subaccountId, page = 1, searchQuery = "") {
    const option = {
      url: `${urls.aspariaBackend}api/v1/getDeptByUserAndSubAccount?${
        page ? "page=" + page : ""
      }${subaccountId ? "&subAccountId=" + subaccountId : ""}${
        searchQuery ? "&name=" + searchQuery : ""
      }`,
    };
    return axios.get(option);
  }

  loginWithDept(obj) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/loginWithDepartment`,
      data: obj,
    };
    return axios.post(option);
  }

  getNotificationPermission() {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/notification-permission`,
    };
    return axios.get(option);
  }

  SSOLogin() {
    const option = {
      url: `${urls.aspariaBackend}api/v1/portal-sso`,
    };
    return axios.get(option);
  }

  getShiftTimings() {
    const option = { url: `${urls.aspariaBackend}api/v1/checkChatWindow` };
    return axios.get(option);
  }
}
